module.exports = __webpack_public_path__ + "static/media/College_of_Liberal_Arts_Short-term_Research.ba5e80ec.doc";